import useMediaQuery from "@mui/material/useMediaQuery";
import { useState } from "react";
import { useDispatch } from "react-redux";
import {
  BoxContainer,
  BoxImage,
  CardContainer,
  CloseButton,
  CloseIcon,
} from "./styles";

const FALLBACK_LINK = "/worthy";
const FALLBACK_WEB_IMAGE =
  "https://assets.wobbjobs.com/images/hiredly/job-worth-calculator-web.png";
const FALLBACK_MOBILE_IMAGE =
  "https://assets.wobbjobs.com/images/hiredly/job-worth-calculator-tablet.png";

function JobEventCard(props) {
  const { webImage, tabletImage, mobileImage, link } = props;

  const isMobile = useMediaQuery("(max-width: 640px)");
  const isTablet = useMediaQuery("(max-width: 1280px)");

  const [showCard, setShowCard] = useState(true);
  const dispatch = useDispatch();

  // Each breakpoint falls back to the next widest artwork the CMS provided
  const resolvedWebImage = webImage || tabletImage || mobileImage;
  const resolvedTabletImage = tabletImage || resolvedWebImage;
  const resolvedMobileImage = mobileImage || resolvedTabletImage;

  const cmsImage = isMobile
    ? resolvedMobileImage
    : isTablet
    ? resolvedTabletImage
    : resolvedWebImage;

  const imageSrc =
    cmsImage || (isMobile ? FALLBACK_MOBILE_IMAGE : FALLBACK_WEB_IMAGE);

  return (
    <CardContainer visibility={showCard}>
      <BoxContainer
        position={"relative"}
        alignItems={"flex-start"}
        sx={{ width: "100%" }}
      >
        <BoxImage
          onClick={() => {
            window.open(link || FALLBACK_LINK);
          }}
          src={imageSrc}
        />
      </BoxContainer>

      <CloseButton
        onClick={() => {
          setShowCard(false);
        }}
      >
        <CloseIcon />
      </CloseButton>
    </CardContainer>
  );
}

export default JobEventCard;
